export default __webpack_public_path__ + "static/media/amex.8aba305c.png";